export default "__VITE_ASSET__CbltuLmN__"